import { render } from "./SubirArchivo.vue?vue&type=template&id=4a1773e8"
import script from "./SubirArchivo.vue?vue&type=script&lang=js"
export * from "./SubirArchivo.vue?vue&type=script&lang=js"

import "./SubirArchivo.vue?vue&type=style&index=0&id=4a1773e8&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\autfis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__